import { Box, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, Typography } from '@mui/material';
import React, { useState } from 'react';
import { read, utils } from 'xlsx';
import { FileUploaderRipik } from '../FileUploaderRipik';
import { handle_po_data_update, handle_po_date_update, handle_po_upload } from '../../../../redux/po_backlog/po.action';
import { useDispatch, useSelector } from 'react-redux';
import { get_po_backlog_state } from '../../../../redux/po_backlog/backlog.selector';
import StyledTableCell from '../../../../common/components/Table/StyledTableCell';
import { po_columns } from './helper/po_columns';
import ControlledTableSelect from '../../../../common/components/Table/ControlledTableSelect';
import ControlledTableDatePicker from '../../../../common/components/Table/ControlledTableDatePicker';
import ControlledTableTextInput from '../../../../common/components/Table/ControlledTableTextInput';
import { get_po_download_progress, get_po_upload_progress } from '../../../../redux/po_backlog/po.selector';
import LinearWithValueLabel from '../../../../common/components/ProgressBar/LinearProgressWithLabel';

const styles = {
  paginationContainer: {
    position: 'sticky',
    bottom: 0,
    left: 0,
    background: 'white',
    zIndex: 1,
  },
};

const OpenPOInputTable = () => {
  const dispatch = useDispatch();
  const po_backlog_object = useSelector(get_po_backlog_state);
  // console.log(po_backlog_object);
  const handle_po_file_input_update = (key_to_be_updated, file) => {
    if (file) {
      //   console.log("reading uploaded file");
      const reader = new FileReader();
      reader.onload = (event) => {
        const workbook = read(event.target?.result, { type: "binary" });
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
        const jsonData = utils.sheet_to_json(worksheet, { header: 1 });
        console.log({ jsonData });
        dispatch(handle_po_upload(jsonData, file));
      };
      reader.readAsBinaryString(file);
    }
  };

  const update_input_object = (key_to_be_updated, file) => {
    handle_po_file_input_update(key_to_be_updated, file);
  };

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // const retrieve_data = () => {
  //   set_loading_data(true);
  //   console.log("fetching data");
  //   const table_data = JSON.parse(localStorage.getItem("po_table_data") || "[]");
  //   const columns = JSON.parse(localStorage.getItem("po_columns") || "[]");
  //   console.log({ table_data, columns });
  //   if (table_data && columns && table_data.length > 0 && columns.length > 0) {
  //     set_po_object(prev => ({
  //       ...prev,
  //       open_po: {
  //         ...prev.open_po,
  //         columns,
  //         table_data
  //       }
  //     }));
  //   }
  //   setTimeout(() => {
  //     set_loading_data(false);
  //   }, 2000);
  // };

  // useEffect(() => {
  //   retrieve_data();
  // }, []);

  const po_upload_progress = useSelector(get_po_upload_progress);
  const po_download_progress = useSelector(get_po_download_progress);

  // useEffect(() => {
  //   console.log({ po_backlog_object });
  // }, [po_backlog_object]);

  return (
    <div>
      <Box>
        <Box className="mb-4">
          <Typography color="text.secondary" fontSize="16px" fontWeight="500" letterSpacing="0.15">
            {
              // stage_name
              // "Upload OPEN PO Document"
            }
          </Typography>
        </Box>
        <TableContainer className='my-4' component={Paper} >
          <Table>
            <TableHead>
              <TableRow
                sx={{
                  bgcolor: "#A6C4DC",
                  textTransform: "capitalize",
                }}
              >
                <TableCell>File Name</TableCell>
                <TableCell>File</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {Object.entries(po_backlog_object).filter(([key, value]) => { return key === "po" && value.visible; }).map(([key, value], idx) => (
                <TableRow
                  key={`${idx}-${key}`}
                  sx={{
                    border: "1px solid #ebebeb",
                    textTransform: "capitalize",
                  }}
                >
                  {/* <TableCell>{idx + 1}</TableCell> */}
                  <TableCell className="uppercase">{value.display_name.split("_").join(" ")}</TableCell>
                  {/* <TableCell>{value.category}</TableCell> */}
                  <TableCell>
                    <FileUploaderRipik
                      key={`${key}-${idx}-file_uploader`}
                      file={value.file}
                      name={key}
                      file_update_function={(file) => {
                        console.log({ file });
                        update_input_object(key, file);
                      }}
                    />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        <Box>
          {
            po_upload_progress.progress && <Box>
              Uploading Data
              <LinearWithValueLabel value={po_upload_progress.progress} />
            </Box>
          }
          {
            po_download_progress.progress && <Box>
              {/* Loading Data */}
              <LinearWithValueLabel value={po_download_progress.progress} />
            </Box>
          }
        </Box>
        {
          po_backlog_object.po.columns && po_backlog_object.po.table_data &&
          <Box className="w-full">
            {/* <CustomDataGrid
              rows={po_backlog_object.po.table_data.map(item => ({ ...item, id: item.order }))}
              columns={po_backlog_object.po.columns}
              pagination
              initialState={{ pagination: { paginationModel: { pageSize: 10 } } }}
              pageSizeOptions={[10, 25, 50, 100]}
            /> */}
            <TableContainer className='' component={Paper}>
              <Table>
                <TableHead>
                  <TableRow>
                    {
                      po_backlog_object.po.columns.map((header, index) =>
                        <StyledTableCell
                          key={`po-table-column-${index}-${header.field}`}
                          sx={{
                            minWidth: po_columns[header.field].type === "text" ? 200 : po_columns[header.field].type === "number" ? 100 : po_columns[header.field].type === "select" ? 200 : 200,
                            maxWidth: 400,
                          }}
                        >
                          {header.headerName}
                        </StyledTableCell>)
                    }
                  </TableRow>
                </TableHead>
                <TableBody>
                  {
                    po_backlog_object.po.table_data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                      .map((row_data, index) => <TableRow key={`po-table-row-${row_data.id}-${index}`}>
                        {
                          po_backlog_object.po.columns.map(({ field, headerName }, index) => {
                            // console.log(po_columns[field]);
                            if (!po_columns[field].isEditable) {
                              return <StyledTableCell
                                key={`row-data-cell-${row_data[field]}-${field}-${index}`}
                              >
                                {row_data[field]}
                              </StyledTableCell>;
                            }
                            if (po_columns[field].type === "select") {
                              return <StyledTableCell key={`row-data-cell-select-${row_data[field]}-${field}-${index}`}>
                                <ControlledTableSelect
                                  excel_row={row_data}
                                  key_name={field}
                                  on_change_handler={(e, state, excel_row, id, key_name) => {
                                    console.log({ e, state, excel_row, id, key_name });
                                    dispatch(handle_po_data_update(excel_row, state, key_name, e.target.value));
                                  }}
                                  select_options={po_columns[field].options}
                                  select_status={row_data[field]}
                                  state={po_backlog_object}
                                  label={headerName}
                                />
                              </StyledTableCell>;
                            }
                            if (po_columns[field].type === "date") {
                              return <StyledTableCell key={`row-data-cell-select-${row_data[field]}-${field}-${index}`}>
                                <ControlledTableDatePicker
                                  excel_row={row_data}
                                  key_name={field}
                                  on_change_handler={(e, ...rest) => {
                                    console.log({ e, rest });
                                    console.log(po_backlog_object, e, row_data, field, row_data.order);
                                    dispatch(
                                      handle_po_date_update(po_backlog_object, e, row_data, field, row_data.order)
                                    );
                                  }}
                                />
                              </StyledTableCell>;
                            }
                            if (po_columns[field].type === "text") {
                              return <StyledTableCell key={`row-data-cell-select-${row_data[field]}-${field}-${index}`}>
                                <ControlledTableTextInput
                                  excel_row={row_data}
                                  key_name={field}
                                  label={headerName}
                                  on_change_handler={(e, ...rest) => {
                                    console.log({ e, rest });
                                    dispatch(handle_po_data_update(row_data, po_backlog_object, field, e.target.value));
                                  }}
                                  state={po_backlog_object}
                                  text_value={row_data[field]}
                                />
                              </StyledTableCell>;

                            }
                            return <StyledTableCell key={`row-data-cell-${row_data[field]}-${field}-${index}`} >{row_data[field]}</StyledTableCell>;
                          })
                        }
                      </TableRow>)
                  }
                </TableBody>
              </Table>
              <TablePagination
                className="paginationContainer"
                sx={styles.paginationContainer}
                rowsPerPageOptions={[10, 15, 20]}
                component="div"
                count={po_backlog_object.po.table_data.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </TableContainer>
          </Box>
        }
      </Box>
    </div>
  );
};

export default OpenPOInputTable;